import { ZONE_BOUNDS } from '@thottbot/shared';

const MAP_NAMES: Record<number, string> = { 0: 'Eastern Kingdoms', 1: 'Kalimdor' };

/** Maps with exactly one client zone (Forever's new islands) are named after that zone. */
function mapName(map: number): string {
  if (MAP_NAMES[map]) return MAP_NAMES[map];
  const zones = ZONE_BOUNDS.zones.filter((z) => z.mapId === map);
  return zones.length === 1 ? zones[0]!.name : `Map ${map}`;
}

/**
 * Raw world coordinates as a compact table. Addon-observed spawn points carry a sighting
 * count; the column appears only when at least one row has one.
 */
export function Locations({
  locations,
}: {
  locations: { map: number; x: number; y: number; count?: number }[] | undefined;
}) {
  if (!locations || locations.length === 0) return null;
  const counted = locations.some((l) => l.count !== undefined);
  const ordered = counted ? [...locations].sort((a, b) => (b.count ?? 0) - (a.count ?? 0)) : locations;
  const shown = ordered.slice(0, 20);
  return (
    <div>
      <table className="grid" style={{ width: 'auto' }}>
        <thead>
          <tr>
            <th>Map</th>
            <th>X</th>
            <th>Y</th>
            {counted && <th>Sightings</th>}
          </tr>
        </thead>
        <tbody>
          {shown.map((l, i) => (
            <tr key={i}>
              <td>{mapName(l.map)}</td>
              <td>{l.x}</td>
              <td>{l.y}</td>
              {counted && <td>{l.count ?? ''}</td>}
            </tr>
          ))}
        </tbody>
      </table>
      {locations.length > shown.length && (
        <span className="muted">and {locations.length - shown.length} more spawn points</span>
      )}
    </div>
  );
}
